import { render, staticRenderFns } from "./TextWithBorder.vue?vue&type=template&id=497c9561&scoped=true"
import script from "./TextWithBorder.vue?vue&type=script&lang=ts"
export * from "./TextWithBorder.vue?vue&type=script&lang=ts"
import style0 from "./TextWithBorder.vue?vue&type=style&index=0&id=497c9561&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c9561",
  null
  
)

export default component.exports